import { addIndex, map } from 'ramda'

export default addIndex(map)
